import { render, staticRenderFns } from "./SafetyDevDialog.vue?vue&type=template&id=2ef314e8&scoped=true&"
import script from "./SafetyDevDialog.vue?vue&type=script&lang=js&"
export * from "./SafetyDevDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef314e8",
  null
  
)

export default component.exports